import { client } from 'components/ApolloProvider'
import { GET_PRICE_LISTS } from './getPriceLists'
import { GET_PRICE_LIST } from './getPriceList'
import { CREATE_PRICE_LIST } from './createPriceList'
import { UPDATE_PRICE_LIST } from './updatePriceList'
import { REMOVE_PRICE_LIST } from './removePriceList'
import {
  CreatePriceListFR,
  GetPriceListAQR,
  GetPriceListsAQR,
  RemovePriceListFR,
  UpdatePriceListFR,
} from './types'
import {
  gridToPricings,
  PriceListModel,
} from '../../pages/PriceLists/models/price-list-form-slice.model'

const priceListsApi = {
  getPriceLists: (queryVariables: { first?: number; last?: number }): Promise<GetPriceListsAQR> =>
    client.query({
      query: GET_PRICE_LISTS,
      variables: {
        first: queryVariables.first ?? null,
        last: queryVariables.last ?? null,
      },
      fetchPolicy: 'network-only',
    }),

  getPriceList: (id: string): Promise<GetPriceListAQR> =>
    client.query({
      query: GET_PRICE_LIST,
      variables: { id },
      // The cache is configured with `addTypename: false`, so it can't match the
      // `... on PricingPlan` inline fragment on read-back and would drop every
      // field (returning an empty `node`). `no-cache` returns the raw network
      // response instead, keeping the edit form prefill intact.
      fetchPolicy: 'no-cache',
    }),

  createPriceList: (priceList: PriceListModel): Promise<CreatePriceListFR> =>
    client.mutate({
      mutation: CREATE_PRICE_LIST,
      variables: {
        name: priceList.name,
        pricings: gridToPricings(priceList.pricing),
      },
    }),

  updatePriceList: (priceList: PriceListModel): Promise<UpdatePriceListFR> =>
    client.mutate({
      mutation: UPDATE_PRICE_LIST,
      variables: {
        id: priceList.id,
        name: priceList.name,
        pricings: gridToPricings(priceList.pricing),
      },
    }),

  removePriceList: (variables: { id: string }): Promise<RemovePriceListFR> =>
    client.mutate({
      mutation: REMOVE_PRICE_LIST,
      variables,
    }),
}

export default priceListsApi
